import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TextComponent } from '../text/text.component';
import { AddressComponent } from '../address/address.component';
import { ListComponent } from '../list/list.component';
import { ContentType, Section } from '../../../pages/common/data-privacy/data-privacy.interface';

@Component({
  selector: 'app-section',
  imports: [TextComponent, AddressComponent, ListComponent, SectionComponent],
  templateUrl: './section.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionComponent {
  protected ContentType = ContentType;

  readonly section = input.required<Section>();
  readonly hierarchyPath = input<number[]>([]);

  readonly sectionTitle = computed(
    () => `${this.hierarchyPath().join('.')} ${this.section().title}`
  );

  public getHierarchyPathChild(index: number): number[] {
    return [...this.hierarchyPath(), index + 1];
  }
}
